import { Button } from './Button'

interface Props {
  open: boolean
  onClose: () => void
}

export function HelpSheet({ open, onClose }: Props) {
  return (
    <div
      className={`overlay${open ? ' open' : ''}`}
      role="dialog"
      aria-modal="true"
      aria-labelledby="help-title"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose()
      }}
    >
      <div className="sheet">
        <h3 id="help-title">Shortcuts</h3>
        <ul>
          <li>
            <span>Workspace tabs</span>
            <span>
              <kbd>1</kbd>–<kbd>6</kbd>
            </span>
          </li>
          <li>
            <span>Refresh</span>
            <kbd>R</kbd>
          </li>
          <li>
            <span>Detect patterns</span>
            <kbd>D</kbd>
          </li>
          <li>
            <span>Inbox focus next / prev</span>
            <span>
              <kbd>J</kbd> / <kbd>K</kbd>
            </span>
          </li>
          <li>
            <span>Confirm focused</span>
            <kbd>C</kbd>
          </li>
          <li>
            <span>Dismiss focused</span>
            <kbd>X</kbd>
          </li>
          <li>
            <span>This help</span>
            <kbd>?</kbd>
          </li>
        </ul>
        <div style={{ marginTop: 14 }}>
          <Button size="sm" onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </div>
  )
}
